<template>
  <el-dialog
    :title="id ? $t('atualizar-unidade') : $t('adicionar-novo-unidade')"
    :visible.sync="dialog"
    :before-close="close"
    width="70%"
    class="unit-modal-wrapper"
    custom-class="unit-modal"
  >
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" size="small">
      <el-row :gutter="12">
        <el-col :xs="24" :sm="6" :md="5" :lg="4">
          <el-form-item :label="$t('codigo')" prop="code">
            <el-input ref="code" v-model="ruleForm.code" :disabled="!!id"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="13" :lg="14">
          <el-form-item :label="$t('nome')" prop="name">
            <el-input ref="name" v-model="ruleForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6" :lg="6">
          <el-form-item :label="$t('ativo')" prop="active" class="is-required">
            <el-switch v-model="ruleForm.active" inactive-color="#ff4949"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :xs="24" :sm="6" :md="5" :lg="4">
          <el-form-item :label="$t('sigla')" prop="acronym">
            <el-input type="text" ref="acronym" maxlength="5" v-model="ruleForm.acronym"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18" :md="19" :lg="20">
          <el-form-item label="Chave Integração" prop="apikey">
            <el-input type="text" ref="apikey" maxlength="160" v-model="ruleForm.apikey"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :xs="24" :sm="12" :md="10" :lg="8">
          <el-form-item :label="$t('faixa-cep')" prop="sourceZipcode">
            <div class="unit-range-fields">
              <el-input maxlength="9" v-model="ruleForm.sourceZipcode" v-mask="'#####-###'" placeholder="Início"></el-input>
              <span class="unit-range-sep">à</span>
              <el-input maxlength="9" v-model="ruleForm.destinyZipcode" v-mask="'#####-###'" placeholder="Fim"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="14" :lg="16">
          <el-form-item prop="viewAcronym" class="unit-inline-check">
            <!-- Rótulo em branco de verdade: mesma altura do rótulo dos campos ao lado -->
            <span slot="label">&nbsp;</span>
            <el-checkbox v-model="ruleForm.viewAcronym" autocomplete="off">Atende Malha +Econômico (Mostrar Sigla na Etiqueta)
              <el-tooltip placement="top" content="Marcado: prepostagens do +Econômico (03298) com destino a esta unidade seguem pela malha e a sigla da unidade aparece na etiqueta. Desmarcado: as rotas de malha com destino a esta unidade ficam sem prazo econômico.">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <UnitMalhaRoutes
        ref="malhaRoutes"
        :rows="malhaRoutes"
        :units="units"
        :unitId="id"
        @add="addRoute"
        @remove="removeRoute"
      />
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t("cancelar") }}</el-button>
      <el-button type="primary" @click="submit">{{ id ? $t("atualizar") : $t("adicionar") }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { UnitService } from "@/services/users/unit.services";
import { i18n } from "@/plugin/i18n";
import UnitMalhaRoutes from "./UnitMalhaRoutes.vue";

// Cadastro/edição de unidade em modal (aberto pela listagem, id vazio = nova).
export default {
  name: "UnitEditDialog",
  components: {
    UnitMalhaRoutes,
  },
  props: {
    dialog: Boolean,
    id: { type: String, default: "" },
    // Lista de unidades já carregada pela listagem (destinos das rotas de malha).
    units: { type: Array, default: () => [] },
  },
  data() {
    return {
      malhaRoutes: [],
      ruleForm: {
        name: "",
        code: "",
        active: true,
        acronym: "",
        sourceZipcode: "",
        destinyZipcode: "",
        apikey: "",
        viewAcronym: true,
      },
      rules: {
        name: [{ required: true, message: i18n.tc("nome-obrigatorio"), trigger: "blur" }],
        code: [{ required: true, message: i18n.tc("codigo-obrigatorio"), trigger: "blur" }],
        acronym: [{ required: true, message: i18n.tc("sigla-obrigatorio"), trigger: "blur" }],
      },
    };
  },
  mounted() {
    const vm = this;
    if (vm.id) {
      vm.get();
    } else {
      vm.$nextTick(() => vm.$refs.name && vm.$refs.name.focus());
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addRoute() {
      this.malhaRoutes.push({
        _key: `${Date.now()}-${Math.random()}`,
        destinyUnitId: "",
        daysExpressCapital: undefined,
        daysExpressInterior: undefined,
        daysEconomicCapital: null,
        daysEconomicInterior: null,
        active: true,
      });
    },
    removeRoute(index) {
      this.malhaRoutes.splice(index, 1);
    },
    formPayload() {
      const vm = this;
      const message = vm.$refs.malhaRoutes ? vm.$refs.malhaRoutes.validate() : "";
      if (message) {
        vm.$message({ type: "error", message });
        return null;
      }
      return Object.assign({}, vm.ruleForm, {
        malhaRoutes: vm.$refs.malhaRoutes ? vm.$refs.malhaRoutes.payload() : [],
      });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      UnitService.get(vm.id)
        .then((response) => {
          vm.ruleForm.name = response.name;
          vm.ruleForm.code = response.code;
          vm.ruleForm.active = response.active;
          vm.ruleForm.apikey = response.apikey;
          vm.ruleForm.acronym = response.acronym;
          vm.ruleForm.destinyZipcode =
            ("" + response.destinyRootStart).padStart(5, "0") +
            "-" +
            ("" + response.destinyDigitStart).padStart(3, "0");
          vm.ruleForm.sourceZipcode =
            ("" + response.sourceRootStart).padStart(5, "0") + "-" + ("" + response.sourceDigitStart).padStart(3, "0");
          vm.ruleForm.viewAcronym = response.viewAcronym;
          vm.malhaRoutes = (response.malhaRoutes || []).map((route) => ({
            _key: route.id,
            id: route.id,
            destinyUnitId: route.destinyUnitId,
            daysExpressCapital: route.daysExpressCapital,
            daysExpressInterior: route.daysExpressInterior,
            daysEconomicCapital: route.daysEconomicCapital,
            daysEconomicInterior: route.daysEconomicInterior,
            active: route.active !== false,
          }));
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error.message || error });
        })
        .finally(() => loading.close());
    },
    submit() {
      const vm = this;
      vm.$refs.ruleForm.validate((valid) => {
        if (!valid) return false;
        const payload = vm.formPayload();
        if (!payload) return false;
        const loading = vm.$loading(vm.$options.loading);
        const request = vm.id ? UnitService.update(vm.id, payload) : UnitService.add(payload);
        request
          .then(() => {
            vm.$message({
              type: "success",
              message: i18n.tc(vm.id ? "unidade-atualizado-sucesso" : "unidade-adicionado-sucesso"),
            });
            vm.$emit("saved");
            vm.$emit("close");
          })
          .catch((error) => {
            vm.$message({ type: "error", message: error.message || error });
          })
          .finally(() => loading.close());
      });
    },
  },
};
</script>
<style>
/* Moldura do modal: altura limitada à janela, corpo rolável (mesmo esquema do PrePostEdit). */
.unit-modal-wrapper {
  display: flex;
}
.unit-modal {
  margin: auto !important;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.unit-modal .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-top: 10px;
}
/* Todos os campos do modal ocupam a largura da coluna */
.unit-modal .el-input,
.unit-modal .el-select,
.unit-modal .el-input-number {
  width: 100%;
}
</style>
<style scoped>
/* Checkbox centralizado na altura do input (32px). O reboot do Bootstrap dá
   margin-bottom ao <label> do el-checkbox, o que o empurrava para cima. */
.unit-inline-check >>> .el-form-item__content {
  display: flex;
  align-items: center;
  min-height: 32px;
}
.unit-inline-check >>> .el-checkbox {
  margin-bottom: 0;
}
.unit-range-fields {
  display: flex;
  align-items: center;
}
.unit-range-sep {
  margin: 0 8px;
  color: #909399;
}
</style>
